import { render, staticRenderFns } from "./Gallery18.vue?vue&type=template&id=ca3676ac&scoped=true&"
import script from "./Gallery18.vue?vue&type=script&lang=js&"
export * from "./Gallery18.vue?vue&type=script&lang=js&"
import style0 from "./Gallery18.vue?vue&type=style&index=0&id=ca3676ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3676ac",
  null
  
)

export default component.exports